import useActions from './useActions'

export const useRemoveSearchParams = () => {
  const actions = useActions()

  return (params?: string[]) => {
    const url = new URL(window.location.toString())
    if (params) {
      actions.removeRouteArgs(params)
      const searchParams = url.searchParams
      for (const param of params) {
        searchParams.delete(param)
      }
    } else {
      actions.clearRouteArgs()
      url.search = ''
    }

    window.history.replaceState({}, document.title, url)
  }
}
